import { Component } from '@angular/core';
import { IconBase } from 'src/app/icons/icon.base';
import { IconConfig } from 'src/app/icons/icon.config';

@Component({
  selector: 'fit-design-substract-icon',
  templateUrl: './design-substract.component.html'
})
export class DesignSubstractComponent extends IconBase {

  constructor(config?: IconConfig) {
    super(config);
  }
}
